<template>
	<div
		:class="{
			sidebar: !side_bar_menu_open,
			'sidebar-open': side_bar_menu_open,
		}">
		<div
			class="d-flex mb-5 px-8 justify-content-between align-items-center"
			style="height: 65px; background-color: #1a1a27">
			<a
				href="#"
				:class="{
					img: !side_bar_menu_open,
					'img-menu-open': side_bar_menu_open,
				}">
				<img alt="Logo" :src="logo" class="h-45px logo" />
			</a>
			<div
				class="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
				:class="{ active: !side_bar_menu_open }"
				@click="openCloseMenu()">
				<span
					class="svg-icon svg-icon-1"
					:class="{ 'rotate-180': !side_bar_menu_open }">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none">
						<path
							d="M14.6 4L6.6 12L14.6 20H10.6L3.3 12.7C2.9 12.3 2.9 11.7 3.3 11.3L10.6 4H14.6Z"
							fill="black"></path>
						<path
							opacity="0.3"
							d="M21.6 4L13.6 12L21.6 20H17.6L10.3 12.7C9.9 12.3 9.9 11.7 10.3 11.3L17.6 4H21.6Z"
							fill="black"></path>
					</svg>
				</span>
			</div>
		</div>

		<sidebar_menu_item
			v-for="(item, index) in side_menu_items"
			:key="index"
			:item="item"
			:side_bar_menu_open="side_bar_menu_open" />
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import sidebar_menu_item from '../../components/menus/sidebar_menu_item.vue';
	import { menuStore } from '../../stores/menu';
	import { computed } from '@vue/reactivity';
	import { usePage } from '@inertiajs/vue3';

	const side_menu_items = computed(() => menuStore().side_menu_items);
	const side_bar_menu_open = ref(true);

	const logo = usePage().props?.logo_img_path as string;

	const emit = defineEmits(['change_side_bar_value']);

	function openCloseMenu() {
		side_bar_menu_open.value = !side_bar_menu_open.value;
		emit('change_side_bar_value', side_bar_menu_open);
	}
</script>

<style scoped>
	.sidebar-open {
		background-color: #1e1e2d;
		height: 100vh;
		width: 310px;
		transition: width 0.3s ease;
		margin-top: 0px;
	}
	.sidebar {
		background-color: #1e1e2d;
		height: 100vh;
		width: 76px;
		position: fixed;
		transition: width 0.3s ease;
	}

	.sidebar:hover {
		width: 270px !important;
	}
	.img {
		display: none;
	}
	.img-menu-open {
		display: block;
	}

	.sidebar:hover .img {
		transition: width 1s;
		transition-delay: 1s;
		display: flex;
	}

	@media screen and (max-width: 768px) {
		.sidebar {
			display: none;
		}
		.sidebar-open {
			display: none;
		}
	}
</style>
